import { withRouter } from 'react-router';
import { compose, withProps } from 'recompose';
import { GqlWorkbench } from '@indica-labs/cmp-gql-workbench';
import { createApolloLink } from './link';
import userManager from '../../userManager';
export default compose(withRouter, withProps(function (_a) {
    var history = _a.history;
    return ({
        createApolloLink: createApolloLink,
        checkToken: function () { return sessionStorage.getItem('authnToken') || 'oidc'; },
        endpoint: '/graphql',
        tokenCheckInterval: 10000,
        logout: function () {
            sessionStorage.removeItem('authnToken');
            userManager.signoutRedirect()
                .catch(function (err) {
                window.location.href = '/graphql';
            });
        },
    });
}))(GqlWorkbench);
